export const isValidDate = (date) => {
    return date instanceof Date && !isNaN(date);
}


export const formatISODateTime = (datetime) => {
    if (!isValidDate(datetime)) {
        return null;
    }
    return datetime.toISOString();
}


export const parseISODateTime = (datetimeString) => {
    const datetime = new Date(datetimeString ?? '');
    if (!isValidDate(datetime)) {
        return null;
    }
    return datetime;

}


export const formatISODate = (date) => {
    if (!isValidDate(date)) {
        return null;
    }
    return `${String(date.getFullYear()).padStart(4, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}


export const parseISODate = (dateString) => {
    const date = new Date(dateString ?? '');
    if (!isValidDate(date)) {
        return null;
    }
    return date;
}


export const formatTime = (date) => {
    if (!isValidDate(date)) {
        return null;
    }
    return date.toISOString().split("T")[1];
}


export const parseTime = (timeString) => {
    const time = new Date(`1970-01-01T${timeString ?? ''}`);
    if (!isValidDate(time)) {
        return null;
    }
    return time;
}


export const getSeasonFromDate = (date) => {
    let year = date.getFullYear();
    if (date.getMonth() < 9){
        year -= 1;
    }
    return {
        label: `${year}/${year + 1}`,
        from: new Date(year, 9, 1),
        to: new Date(year + 1, 8, 30)
    }
}